import { render, staticRenderFns } from "./OptimizedProductlistdetailsPage.vue?vue&type=template&id=201ab92b"
import script from "./OptimizedProductlistdetailsPage.vue?vue&type=script&lang=js"
export * from "./OptimizedProductlistdetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports